import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyToLabel'
})
export class KeyToLabelPipe implements PipeTransform {

  transform(value: string): any {
    if (value != null) {
      value = value.replace(/([A-Z])/g, " $1").replace(/_/g, ' ');
      let words = value.split(' ');
      let finalResult = '';

      for (let word of words) {
        if (word.length > 0) {
          finalResult += word.charAt(0).toUpperCase() + word.slice(1) + ' ';
        }
      }

      finalResult = finalResult.trim();

      if(finalResult === 'Openingbalance') finalResult = 'Opening Balance';
      else if(finalResult === 'Glcode') finalResult = 'Gl Code';
      else if(finalResult === 'Balancetype') finalResult = 'Balance Type';
      else if(finalResult === 'Transtype') finalResult = 'Transaction Type';
      else if(finalResult === 'Incomeorexpense') finalResult = 'Income/Expense'

      return finalResult;
    }
  }

}